import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import { useFormikContext } from "formik";
import PhoneInput from "../../input/PhoneInput";
import EmailInput from "../../input/EmailInput";
import { findPossessiveFor, PartOfSpeech } from "../../common/PersonalLanguage";
import { BeneficiaryFormValues } from "../../common/BeneficiaryFormValues";
import TextInput from "../../input/TextInput";
import StateDropdown from "../../input/StateDropdown";
import ZipCodeInput from "../../input/ZipCodeInput";
import TwoColumnDiv from "../../structure/TwoColumnDiv";
import AddressModal from "../../structure/AddressModal";
import HorizontalRule from "../../structure/HorizontalRule";
import { useGuestAuth } from "../../guest/GuestAuthProvider";
import { useAuth } from "oidc-react";

const ContactBeneficiary = () => {
    const { values, setFieldValue } = useFormikContext<BeneficiaryFormValues>()
    const auth = useAuth();
    const { guestAuth } = useGuestAuth();
    const activeGuestEmail = auth.userData ? undefined : guestAuth?.email?.trim();

    React.useEffect(() => {
        if (activeGuestEmail && !values.beneficiaryEmailAddress?.trim()) {
            setFieldValue('beneficiaryEmailAddress', activeGuestEmail);
        }
    }, [activeGuestEmail, setFieldValue, values.beneficiaryEmailAddress]);

    const nounPossessiveWithArticle = findPossessiveFor(values, true, true, PartOfSpeech.NOUN);
    const adjectivePossessive = findPossessiveFor(values, true, undefined, PartOfSpeech.ADJECTIVE);
    const capitalPossessive = findPossessiveFor(values);
    return (
        <>
            <AddressModal streetAddressField="beneficiaryStreetAddress" cityField="beneficiaryCity" stateField="beneficiaryState"
                zipCodeField="beneficiaryZipCode" />
            <QuestionPanel headerText={`What is ${nounPossessiveWithArticle} contact information?`}
                detailsText={`Your privacy is important to us. We'll only use ${nounPossessiveWithArticle} email for official communication regarding ${adjectivePossessive} claim.`}
                panelContent={
                    <div>
                        <EmailInput id="beneficiary-email-address" label={`${capitalPossessive} email`} required={true} disabled={Boolean(activeGuestEmail)} />
                        <PhoneInput id="beneficiary-phone-number" label={`${capitalPossessive} phone number`} required={true} />
                        <HorizontalRule />
                        <TextInput id="beneficiary-street-address" label={`${capitalPossessive} street address`} required={true} />
                        <TwoColumnDiv leftContent={<TextInput id="beneficiary-city" label={`${capitalPossessive} city`} required={true} />}
                            rightContent={<TwoColumnDiv
                                leftContent={<StateDropdown id="beneficiary-state" label={`${capitalPossessive} state`} required={true} />}
                                rightContent={<ZipCodeInput id="beneficiary-zip-code" label={`${capitalPossessive} ZIP`} required={true} />}>
                            </TwoColumnDiv>} />
                    </div>
                }
            >
            </QuestionPanel>
        </>
    )
};

export default ContactBeneficiary;